import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { EditProjectViewComponent } from './views/edit-project-view/edit-project-view.component';
import { StoreModule } from '@ngrx/store';
import { projectReducer } from './store';
import { EffectsModule } from '@ngrx/effects';
import { ProjectEntityEffects } from './store/project-data/project-data.effects';
import { EntityEditorModule } from '../entity-editor/entity-editor.module';
import { ProjectFormComponent } from './components/project-form/project-form.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { CreateProjectViewComponent } from './views/create-project-view/create-project-view.component';
import { ProductViewComponent } from './views/product-view/product-view.component';
import { ProductEntityEffects } from './store/product-view/product-view.effects';
import { ProductTreeComponent } from './components/product-tree/product-tree.component';
import { ProductEditorComponent } from './components/product-editor/product-editor.component';
import { ProductVisualEditorComponent } from './components/product-visual-editor/product-visual-editor.component';
import { ProjectFileDownloadComponent } from './components/project-file-download/project-file-download.component';
import { ProductMessagesComponent } from './components/product-messages/product-messages.component';
import { RouterModule } from '@angular/router';
import { Visualize3dModule } from '@magicore/visualize-3d';
import { ActiconVisualize3dModule } from '../visualize3d/acticon-visualize3d.module';
import { ProductCopyDialogComponent } from './components/product-copy-dialog/product-copy-dialog.component';
import { ProjectListModule } from '../project-list/project-list.module';
import { CoreModule } from '../core/core.module';
import { MultiEditProductEditorComponent } from './components/multi-edit-product-editor/multi-edit-product-editor.component';
import { MultiEditEntityEditorComponent } from './components/multi-edit-entity-editor/multi-edit-entity-editor.component';
import { MultiEditPropertyEditorComponent } from './components/multi-edit-property-editor/multi-edit-property-editor.component';
import { MultiEditEntitySelectionCheckboxComponent } from './components/multi-edit-entity-selection-checkbox/multi-edit-entity-selection-checkbox.component';
import { MultiEditPropertyTooltipContentComponent } from './components/multi-edit-property-tooltip-content/multi-edit-property-tooltip-content.component';
import { MultiEditPropertyTooltipDirective } from './directives/multi-edit-property-tooltip.directive';
import { ProjectPricesViewComponent } from './views/project-prices-view/project-prices-view.component';
import { ProjectPricesComponent } from './components/project-prices/project-prices.component';
import { ProductTreeOrderByNameAndDepthPipe } from './components/product-tree/pipes/product-tree-order-by-name-and-depth.pipe';
import { ProductMessageLinkComponent } from './components/product-messages/product-message/product-message-link.component';
import { PriceTableNumberInputComponent } from './components/project-prices/price-table-number-input/price-table-number-input.component';
import { AddLineViewComponent } from './views/addline-view/addline-view.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HoodLineComponent } from './views/hoodline-view/hoodline-view.component';
import { HoodLineMessagesComponent } from './components/hoodline-messages/hoodline-messages.component';
import { HoodDataFormComponent } from './components/hood-data-form/hood-data-form.component';

@NgModule({
  declarations: [
    EditProjectViewComponent,
    ProjectFormComponent,
    ProjectFileDownloadComponent,
    ProductListComponent,
    CreateProjectViewComponent,
    ProductViewComponent,
    ProductTreeComponent,
    ProductMessagesComponent,
    ProductEditorComponent,
    HoodLineComponent,
    HoodLineMessagesComponent,
    ProductVisualEditorComponent,
    ProductCopyDialogComponent,
    MultiEditProductEditorComponent,
    MultiEditEntityEditorComponent,
    MultiEditPropertyEditorComponent,
    MultiEditEntitySelectionCheckboxComponent,
    MultiEditPropertyTooltipContentComponent,
    MultiEditPropertyTooltipDirective,
    ProjectPricesViewComponent,
    ProjectPricesComponent,
    AddLineViewComponent,
    ProductTreeOrderByNameAndDepthPipe,
    ProductMessageLinkComponent,
    PriceTableNumberInputComponent,
    HoodDataFormComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    EntityEditorModule,
    StoreModule.forFeature('project', projectReducer),
    EffectsModule.forFeature([ProjectEntityEffects, ProductEntityEffects]),
    Visualize3dModule,
    ActiconVisualize3dModule,
    ProjectListModule,
    CoreModule,
    BrowserAnimationsModule
  ],
  exports: [EditProjectViewComponent, CreateProjectViewComponent]
})
export class ProjectModule {}
